export const H_ADVANCED_PAYMENTS = 'Pagos adelantados';
export const H_BALANCE = 'Saldo';
export const H_BRANCH_OFFICE = 'Sucursal';
export const H_CLIENTS_COUNT = '# Clientes';
export const H_CURRENT_PAYMENT = 'Pago actual';
export const H_CYCLE = 'Ciclo';
export const H_DISBURSEMENT = 'Monto desembolsado';
export const H_DISBURSEMENT_AMOUNT = 'Monto desem.';
export const H_DISBURSEMENT_DATE = 'Fecha desem.';
export const H_END_DATE = 'Fecha término';
export const H_GROUP = 'Grupo';
export const H_INDEX = '#';
export const H_LAST_PAYMENT_DATE = 'Última fecha pago';
export const H_LATE_PAYMENT_AMOUNT = 'Monto atrasado';
export const H_PAID_AMOUNT = 'Monto pagado';
export const H_PAID_TO = 'Pagado al';
export const H_PAYMENT_AMOUNT = 'Monto pago';
export const H_PAYMENT_APPLIED = 'Pago aplicado';
export const H_PAYMENT_DAY = 'Día pago';
export const H_PAYMENTS = 'Pagos';
export const H_PROMOTER = 'Promotor';
export const H_TERM = 'Plazo';
export const H_UP_TO_DATE = 'Pagado al día';
